import vOutsideEvents from 'vue-outside-events';
import {
    Component, Vue,
} from '@samclick-commons';
import { _get } from '@samclick-lodash';
import {
    SamclickInput,
    SamclickWrapper,
    SamclickRow,
    SamclickCol,
    SamclickDialog,
    SamclickSelect,
    SamclickDateRangePicker,
    SamclickDatatable,
    SamclickDatePicker,
    SamclickNumberInput,
    SamclickTableColumn,
    SamclickDateRangePickerType,
    SamclickForm,
    SamclickFormItem,
    SamclickDatatableType,
    SamclickNumber,
    SamclickNumberType,
    SamclickValidation,
    SamclickButton,
    LineChart,
    BarChart,
    PieChart,
} from '@samclick-components';
import { validateRoles } from '@/utils/common-utils';
import i18n from '@/i18next';


Vue.use(vOutsideEvents);

enum SamclickAlert {
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',
    SAVING_PROMPT = 'Are you sure you want to save the data?',
}

const SamclickButtonType = {
    ADD: {
        type: 'success',
        label: 'buttons.create',
        icon: 'fa fa-plus',
    },
    SEARCH: {
        type: 'primary',
        label: 'buttons.search',
        icon: 'fa fa-search',
    },
    RESET: {
        type: 'info',
        label: 'buttons.reset',
        icon: 'fa fa-refresh',
    },
    VIEW: {
        type: 'primary',
        label: 'buttons.view',
    },
    EDIT: {
        type: 'default',
        label: 'buttons.edit',
    },
    SAVE: {
        type: 'success',
        label: 'buttons.save',
    },
    CANCEL: {
        type: 'default',
        label: 'buttons.cancel',
    },
    DELETE: {
        type: 'danger',
        label: 'buttons.delete',
    },
    SUBMIT: {
        type: 'primary',
        label: 'buttons.submit',
    },
    PRIMARY: {
        type: 'primary',
        label: 'Primary',
    },
    DEFAULT: {
        type: 'default',
        label: 'Default',
    },
    INFO: {
        type: 'info',
        label: 'Info',
    },
    DANGER: {
        type: 'danger',
        label: 'Danger',
    },
    WARNING: {
        type: 'warning',
        label: 'Warning',
    },
    SUCCESS: {
        type: 'success',
        label: 'Success',
    },
};

enum ElDatePickerConst {
    MONTH = 'month',
    MONTH_FORMAT = 'MM-yyyy',
    YEAR = 'year',
    DATE_TIME = 'datetime',
}

@Component({
    /**
   * Imported components
   * */
    components: {
        SamclickInput,
        SamclickWrapper,
        SamclickRow,
        SamclickCol,
        SamclickDialog,
        SamclickSelect,
        SamclickDateRangePicker,
        SamclickDatatable,
        SamclickDatePicker,
        SamclickNumberInput,
        SamclickTableColumn,
        SamclickForm,
        SamclickFormItem,
        SamclickNumber,
        SamclickValidation,
        SamclickButton,
        LineChart: LineChart.default,
        BarChart: BarChart.default,
        PieChart: PieChart.default,
    },
    data() {
        return {
            SamclickDateRangePicker: SamclickDateRangePickerType,
            SamclickAlert,
            SamclickDatatable: SamclickDatatableType,
            SamclickNumber: SamclickNumberType,
            ElDatePicker: ElDatePickerConst,
            SamclickValidation: {
                validateRoles,
            },
            SamclickButton: SamclickButtonType,
            BarChart: BarChart.BarChartType,
            LineChart: LineChart.LineChartType,
            PieChart: PieChart.PieChartType,
        };
    },
})
export default class CommonMixins extends Vue {
    emitEventHandler(event: string, ...args: any) {
        this.$emit(event, ...args);
    }

    showAlert(content: string, type: any, showCancel: boolean = false) {
        const title = new Map([
            ['warning', i18n.i18next.t('api_error.header_warning')],
            ['info', i18n.i18next.t('api_error.header_info')],
            ['success', i18n.i18next.t('api_error.header_success')],
            ['error', i18n.i18next.t('api_error.header_error')],
        ]);
        return this.$confirm(content, title.get(type) || '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: i18n.i18next.t('buttons.ok'),
            cancelButtonText: i18n.i18next.t('buttons.cancel'),
            type,
            center: true,
            showCancelButton: showCancel,
            closeOnClickModal: false,
            closeOnPressEscape: false,
        });
    }

    clone(objToClone: any) {
        return JSON.parse(JSON.stringify(objToClone));
    }

    showErrorAlert() {
        this.showAlert(i18n.i18next.t('api_error.prompt_unknown_err'), this.$data.SamclickAlert.ERROR);
    }

    showSuccessAlert() {
        this.showAlert(i18n.i18next.t('api_error.prompt_save_ok'), this.$data.SamclickAlert.SUCCESS);
    }

    resetPagination(tableRef: string) {
        this.$refs[tableRef].resetPagination();
    }

    getObject(obj: object, path: string, defaultVal: any) {
        return _get(obj, path, defaultVal);
    }

    get ifLocaleChange() {
        return this.$i18n.i18nLoadedAt;
    }

    isAllowedElement(e: object) {
        const { tagName } = e.target;
        const keyboardKey = e.key;

        const whiteListElement = ['body', 'input', 'label'];

        if (keyboardKey === 'Enter' && tagName.toLowerCase() === 'input') {
            e.target.blur();
        }

        return keyboardKey === 'Enter' && whiteListElement.indexOf(tagName.toLowerCase()) > -1;
    }
}
